import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  deleteShoutoutDeliverables,
  getShoutoutDeliverableById,
  getShoutoutDeliverableV2ById,
} from '../../../../../ajax';
import { ShoutoutDeliverable, SLICE_NAME } from './types';

interface FetchShoutoutDeliverablePayload {
  campaignId: number;
  shoutoutDeliverableId: number;
  v2: boolean;
}

export const fetchShoutoutDeliverable = createAsyncThunk<
  ShoutoutDeliverable,
  FetchShoutoutDeliverablePayload
>(
  `${SLICE_NAME}/fetchShoutoutDeliverablesPage`,
  async ({ campaignId, shoutoutDeliverableId, v2 }) => {
    if (v2) {
      const deliverable: ShoutoutDeliverable =
        await getShoutoutDeliverableV2ById(campaignId, shoutoutDeliverableId);

      const socialShoutouts = (deliverable.social_media_shoutouts || []).map(
        (item) => {
          return {
            ...item,
            video_id: item.social_post_id,
          };
        }
      );

      return {
        ...deliverable,
        v2: true,
        shoutouts: [...deliverable.shoutouts, ...socialShoutouts],
      };
    }

    return getShoutoutDeliverableById(campaignId, shoutoutDeliverableId);
  }
);

interface DeleteShoutoutPayload {
  campaignId: number;
  shoutoutId: number;
  shoutoutDeliverableId: number;
}

export const deleteShoutout = createAsyncThunk(
  `${SLICE_NAME}/deleteShoutout`,
  ({ campaignId, shoutoutId, shoutoutDeliverableId }: DeleteShoutoutPayload) =>
    deleteShoutoutDeliverables(shoutoutDeliverableId, campaignId, shoutoutId)
);
